export const theWindow = typeof window !== 'undefined' ? window : undefined
export const theDocument = typeof document !== 'undefined' ? document : undefined
export const isBrowser = theWindow && theDocument
